import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const Headphones = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M20.085 17c.5-1.5.915-3.563.915-5a9 9 0 0 0-18 0c0 1.437.415 3.5.915 5m5.062 2.604-1.738-4.991c-.186-.466-.777-.7-1.264-.583a2.9 2.9 0 0 0-1.828 3.66l.438 1.326a2.88 2.88 0 0 0 3.643 1.836c.461-.196.876-.762.749-1.248m6.047 0 1.737-4.991c.186-.466.777-.7 1.264-.583a2.9 2.9 0 0 1 1.828 3.66l-.438 1.326a2.88 2.88 0 0 1-3.643 1.836c-.461-.196-.876-.762-.748-1.248"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(Headphones) as SvgIcon;
export { ForwardRef as ReactComponent };
